import * as React from 'react';
import Box from '@mui/material/Box';

export default function Logo() {
  return (
    <Box
      component="img"
      src="/logo.svg"
      alt="UnicornGenerator Logo"
      sx={{
        height: 40,
        width: 'auto',
        display: 'block'
      }}
    />
  );
}